<div class="card-title-block-non-sticky" *ngIf="hasOrderDetailsError && !isLoading">
	<copo-back-button></copo-back-button>
	<span class="card-title-label" translate>order-card.data-not-found</span>
</div>
<div class="sidenav-content" *ngIf="!(hasOrderDetailsError && !isLoading)">
	<ng-container *ngIf="!isOffline; else offline">
		<ng-container *ngIf="!isLoading else loading">
			<ng-container *ngIf="order && !hasOrderDetailsError">
				<div class="card-title-block-non-sticky">
					<copo-back-button></copo-back-button>
					<span class="card-title-label" translate>order.card</span>
					<span class="card-title-label">{{ order.customerOrderNumber }}/{{ order.customerOrderItemNumber
						}}</span>
					<span class="card-title-label">{{ order.supplierOrderNumber }}/{{ order.supplierOrderItemNumber
						}}</span>
					<span *ngIf="hasExceptionReportService">
						<mat-icon [svgIcon]="isEdit ? 'md:pinFilled' : 'md:pin'"></mat-icon>
					</span>
					<div class="elink-container">
						<button type="button" mat-flat-button
							*ngIf="user.hasService('PCALL') && callableBatchesCount > 0" (click)="startCallOff()">
							<span translate>batch-card.create-call-off</span>
							<mat-icon iconPositionEnd class="icon-color" svgIcon="add"></mat-icon>
						</button>
						<button type="button" mat-flat-button
							(click)="openCommentDialog()" *ngIf="hasExceptionReportService">
							<span>{{ getButtonName() }}</span>
							<mat-icon iconPositionEnd class="icon-color" [svgIcon]="isEdit ? 'md:pinFilled' : 'md:pin'"></mat-icon>
						</button>
						<button type="button" *ngIf="this.order.isFavorite" [disabled]="isDisabled" mat-icon-button
							color="primary" (click)="deleteFavoriteOrder()">
							<mat-icon svgIcon="md:star"></mat-icon>
						</button>
						<button type="button" *ngIf="!this.order.isFavorite" [disabled]="isDisabled" mat-icon-button
							color="primary" (click)="saveFavoriteOrder()">
							<mat-icon svgIcon="md:star_border"></mat-icon>
						</button>
						<button *ngIf="millEmail" type="button" mat-flat-button (click)="openElinkDialog()">
							<span translate>elink.contact-mill</span>
							<mat-icon class="icon-color" *ngIf="millEmail" iconPositionEnd svgIcon="mail"></mat-icon>
						</button>
					</div>
				</div>
				<div class="grid-6 copo-container">
					<div class="grid-column-one-full">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate>order.card.information</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="card-content-block">
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>order.supplier</div>
										<div class="card-content-value">{{ order | copoModelInfo:'supplierDescription'
											}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.mill</div>
										<div class="card-content-value">{{ order | copoModelInfo:'millDescription' }}
										</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.responsible.order.manager</div>
										<div class="card-content-value">{{ order |
											copoModelInfo:'orderManagerDescription' }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.provisional.item</div>
										<div class="card-content-value">{{ getProvisionalOrFirmItem() }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.service.level</div>
										<div class="card-content-value">{{ order |
											copoModelInfo:'serviceLevelDescription' }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.service.request</div>
										<div class="card-content-value">{{ order |
											copoModelInfo:'serviceRequestDescription' }}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>order.creation.date</div>
										<div class="card-content-value">{{ order.orderCreationDate | copoDate:'date' }}
										</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.sales.quarter</div>
										<div class="card-content-value">{{ order | copoModelInfo:'salesQuarter' }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.reason</div>
										<div class="card-content-value">{{ order |
											copoModelInfo:'orderReasonDescription' }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.prevision.item</div>
										<div class="card-content-value">{{ getPrevisionItem() }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.card.xcarb</div>
										<div class="card-content-value">{{ order | copoModelInfo:'xcarbDescription' }}
										</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>settings.order.customer</div>
										<div class="card-content-value">{{ order.customerOrderNumber }}/{{
											order.customerOrderItemNumber }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>settings.order.supplier</div>
										<div class="card-content-value">{{ order.supplierOrderNumber }}/{{
											order.supplierOrderItemNumber }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>
											application.procurement.supplier.rfqNumber</div>
										<div class="card-content-value">{{ order.supplierRFQNumber ?
											order.supplierRFQNumber : UNDERSCORE }}{{ order.supplierRFQNumber &&
											order.supplierRFQItemNumber ? '/' : '' }}{{ order.supplierRFQNumber &&
											order.supplierRFQItemNumber ? order.supplierRFQItemNumber : '' }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.mill.order.number</div>
										<div class="card-content-value">{{ order.millOrderNumber ? order.millOrderNumber
											+ "/" + order.millOrderItemNumber : UNDERSCORE }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.contract.number</div>
										<div class="card-content-value">{{ order.supplierContractNumber || UNDERSCORE }}
										</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>datacenter-filter.item-sold-to-party
										</div>
										<div class="card-content-value">{{ order.itemReferenceSoldToParty || UNDERSCORE
											}}</div>
									</div>
								</div>
							</div>
						</mat-expansion-panel>
					</div>
					<div class="grid-column-one-full">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate>order.card.followup</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="card-content-block">
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>order.item.status</div>
										<div class="card-content-value">{{ order |
											copoModelInfo:'orderItemStatusDescription' }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.ordered</div>
										<div class="card-content-value">{{ order.grossQtyOrdered | copoNumber:
											'weight':'t' }}</div>
									</div>
									<div class="card-content-info" *ngIf="user.hasService('PCALL')">
										<div class="card-content-label" translate>order.callable.gross.weight</div>
										<div class="card-content-value">{{ callableGrossWeight | copoNumber:
											'weight':'t' }}</div>
									</div>
									<div class="card-content-info" *ngIf="user.hasService('PCALL')">
										<div class="card-content-label" translate>order.called.gross.weight</div>
										<div class="card-content-value">{{ calledGrossWeight | copoNumber: 'weight':'t'
											}}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.sales.quarter</div>
										<div class="card-content-value">{{ order | copoModelInfo:'salesQuarter' }}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>order.interpretation.delivery.date
										</div>
										<div class="card-content-value">{{ order |
											copoModelInfo:'interpretationDeliveryDate' }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.rdd</div>
										<div class="card-content-value">{{ order.rddWeek | copoDate:'week' }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.confirmed.delivery.date</div>
										<div class="card-content-value">{{ checkCddWeekData() }}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>order.first.batch.in.stock</div>
										<div class="card-content-value">{{ order.grossFirstBatchInStock ?
											(order.grossFirstBatchInStock | copoDate:'week') : UNDERSCORE }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.last.batch.in.stock</div>
										<div class="card-content-value">{{ order.grossLastBatchInStock ?
											(order.grossLastBatchInStock | copoDate:'week') : UNDERSCORE }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.stock-alert</div>
										<div class="card-content-value"> <mat-icon
												[svgIcon]="getStockAlertIcon(order.grossStockAlert)"
												[title]="getStockAlertTranslation(order.grossStockAlert) | translate"></mat-icon>
										</div>
									</div>
								</div>
							</div>
						</mat-expansion-panel>
					</div>
					<div class="grid-column-two-third"
						*ngIf="orderStatusData && orderStatusData.length > 0 && gridOrderStatusOptions">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate>order.order-status</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="copo-card-grid-container card-grid-padding">
								<ag-grid-angular class="ag-theme-balham" [gridOptions]="gridOrderStatusOptions"
									[components]="orderStatusFrameworkComponents" [modules]="agGridModules"
									(gridReady)="onGridReady($event)"
									(viewportChanged)="onViewportChanged($event)"></ag-grid-angular>
							</div>
						</mat-expansion-panel>
					</div>
					<div class="grid-column-one-third" *ngIf="gridInProductionOptions">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate class="in-productopn-label">order-tracking.in.production</span>
									<span class="in-productopn-label" *ngIf="sumInProduction">
										{{ sumInProduction | copoNumber: 'weight':'t' }}</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="copo-card-grid-container card-grid-padding">
								<ag-grid-angular class="ag-theme-balham" [gridOptions]="gridInProductionOptions"
									[overlayNoRowsTemplate]="overlayNoRowsTemplate" [modules]="agGridModules"
									(gridReady)="onGridReady($event)"
									(viewportChanged)="onViewportChanged($event)"></ag-grid-angular>
							</div>
						</mat-expansion-panel>
					</div>
					<div class="grid-column-one-half">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate>order.customer</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="card-content-block">
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>order.customer</div>
										<div class="card-content-value">{{ order | copoModelInfo:'soldToDescription' }}
										</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.ship.to</div>
										<div class="card-content-value">{{ order | copoModelInfo:'shipToDescription' }}
										</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>order.enduser</div>
										<div class="card-content-value">{{ order | copoModelInfo:'endUserDescription' }}
										</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.bill.to</div>
										<div class="card-content-value">{{ order | copoModelInfo:'billToDescription' }}
										</div>
									</div>
								</div>
							</div>
						</mat-expansion-panel>
					</div>
					<div class="grid-column-one-half">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate>order.delivery</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="card-content-block">
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>order.delivery.address</div>
										<div class="card-content-value">{{ order | copoModelInfo:'deliveryAddress' }}
										</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.transport-mode</div>
										<div class="card-content-value">{{ order |
											copoModelInfo:'transportModeDescription' }}</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info">
										<div class="card-content-label" translate>order.incoterm</div>
										<div class="card-content-value">{{ order | copoModelInfo:'incoterm' }}</div>
									</div>
									<div class="card-content-info">
										<div class="card-content-label" translate>order.delivery.mode</div>
										<div class="card-content-value">{{ order |
											copoModelInfo:'deliveryModeDescription' }}</div>
									</div>
								</div>
							</div>
						</mat-expansion-panel>
					</div>
					<div class="grid-column-one-half"
						*ngIf="hasExceptionReportService && exceptionReportToDisplay && exceptionReportToDisplay.length>0">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate>exception-report.order-card-header</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="exception-report-block"
								*ngFor="let exceptionReport of exceptionReportToDisplay">
								<mat-icon svgIcon="md:pin"></mat-icon>
								<span class="week">{{buildYearWeek(exceptionReport.yearWeek)}}</span>
								<div class="card-infos"
									*ngIf="exceptionReport.commentFromCustomer && exceptionReport.commentFromCustomer.length > 0">
									<div class="card-info">
										<span class="card-info-label"
											translate>exception-report.comment-by-customer</span>
										<span class="card-info-value">{{exceptionReport.commentFromCustomer}}</span>
									</div>
								</div>
								<div class="card-infos"
									*ngIf="exceptionReport.commentFromCuse && exceptionReport.commentFromCuse.length > 0">
									<div class="card-info">
										<span class="card-info-label" translate>exception-report.comment-by-am</span>
										<span class="card-info-value">{{exceptionReport.commentFromCuse}}</span>
									</div>
								</div>
							</div>
						</mat-expansion-panel>
					</div>
					<div class="card-block grid-column-one-full"
						*ngIf="orderCharacteristics && orderCharacteristics.length>0">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span translate>order-tracking.product</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="card-content-block">
								<div class="card-contents-infos">
									<div class="card-content-info" *ngIf="order.productDescription">
										<div class="card-content-label" translate>order-tracking.product.description
										</div>
										<div class="card-content-value">{{ order.productDescription }}</div>
									</div>
									<div class="card-content-info" *ngIf="order.choiceDescription">
										<div class="card-content-label" translate>order-tracking.choice</div>
										<div class="card-content-value">{{ order.choiceDescription }}</div>
									</div>
									<div class="card-content-info" *ngIf="order.customerArticleReference">
										<div class="card-content-label" translate>
											order-tracking.customerArticleReference</div>
										<div class="card-content-value">{{ order.customerArticleReference }}</div>
									</div>
									<div class="card-content-info" *ngIf="order.customerTemplateReference">
										<div class="card-content-label" translate>order.customer-template-reference
										</div>
										<div class="card-content-value">{{ order.customerTemplateReference }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('PA01')">
										<div class="card-content-label">{{ getCharacteristic('PA01')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('PA01') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('US05')">
										<div class="card-content-label">{{ getCharacteristic('US05')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('US05') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('QU01')">
										<div class="card-content-label">{{ getCharacteristic('QU01')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('QU01') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="order.steelgradeDescription">
										<div class="card-content-label" translate>order.steelgrade</div>
										<div class="card-content-value">{{ order.steelgradeDescription }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('SU09')">
										<div class="card-content-label">{{ getCharacteristic('SU09')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('SU09') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="order.thickness">
										<div class="card-content-label" translate>batch-card.thickness</div>
										<div class="card-content-value">{{ order.thickness }}</div>
									</div>
									<div class="card-content-info" *ngIf="order.width">
										<div class="card-content-label" translate>batch-card.width</div>
										<div class="card-content-value">{{ order.width }}</div>
									</div>
									<div class="card-content-info" *ngIf="order.length">
										<div class="card-content-label" translate>batch-card.length</div>
										<div class="card-content-value">{{ order.length }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('WG11')">
										<div class="card-content-label">{{ getCharacteristic('WG11')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('WG11')?.valueNum }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('WG21')">
										<div class="card-content-label">{{ getCharacteristic('WG21')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('WG21') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('WG27')">
										<div class="card-content-label">{{ getCharacteristic('WG27')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('WG27') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('WG97')">
										<div class="card-content-label">{{ getCharacteristic('WG97')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('WG97') | copoCharac }}
										</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info" *ngIf="getCharacteristic('CO01')">
										<div class="card-content-label">{{ getCharacteristic('CO01')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('CO01') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO03')">
										<div class="card-content-label">{{ getCharacteristic('CO03')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('CO03') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO25')">
										<div class="card-content-label">{{ getCharacteristic('CO25')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('CO25') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO15')">
										<div class="card-content-label">{{ getCharacteristic('CO15')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('CO15') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO76')">
										<div class="card-content-label">{{ getCharacteristic('CO76')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('CO76') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO37')">
										<div class="card-content-label">{{ getCharacteristic('CO37')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('CO37') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO19')">
										<div class="card-content-label">{{ getCharacteristic('CO19')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('CO19') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO17')">
										<div class="card-content-label">{{ getCharacteristic('CO17')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('CO17') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO71')">
										<div class="card-content-label">{{ getCharacteristic('CO71')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('CO71') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="order.dataSheetTopSideDescription">
										<div class="card-content-label" translate>datacenter-filter.data-sheet-top-side
										</div>
										<div class="card-content-value">{{ order |
											copoModelInfo:'dataSheetTopSideDescription' }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO80')">
										<div class="card-content-label">{{ getCharacteristic('CO80')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('CO80') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO20')">
										<div class="card-content-label">{{ getCharacteristic('CO20')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('CO20') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO18')">
										<div class="card-content-label">{{ getCharacteristic('CO18')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('CO18') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CO72')">
										<div class="card-content-label">{{ getCharacteristic('CO72')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('CO72') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="order.dataSheetBottomSideDescription">
										<div class="card-content-label" translate>
											datacenter-filter.data-sheet-bottom-side</div>
										<div class="card-content-value">{{ order |
											copoModelInfo:'dataSheetBottomSideDescription' }}</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('SU08')">
										<div class="card-content-label">{{ getCharacteristic('SU08')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('SU08') | copoCharac }}
										</div>
									</div>
								</div>
								<div class="card-contents-infos">
									<div class="card-content-info" *ngIf="getCharacteristic('DI11')">
										<div class="card-content-label">{{ getCharacteristic('DI11')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('DI11') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('DI40')">
										<div class="card-content-label">{{ getCharacteristic('DI40')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('DI40') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('DI12')">
										<div class="card-content-label">{{ getCharacteristic('DI12')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('DI12') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('PP01')">
										<div class="card-content-label">{{ getCharacteristic('PP01')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('PP01') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('DI14')">
										<div class="card-content-label">{{ getCharacteristic('DI14')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('DI14') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('DI33')">
										<div class="card-content-label">{{ getCharacteristic('DI33')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('DI33') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('SU02')">
										<div class="card-content-label">{{ getCharacteristic('SU02')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('SU02') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('SU03')">
										<div class="card-content-label">{{ getCharacteristic('SU03')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('SU03') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('SU12')">
										<div class="card-content-label">{{ getCharacteristic('SU12')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('SU12') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('SU34')">
										<div class="card-content-label">{{ getCharacteristic('SU34')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('SU34') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('US02')">
										<div class="card-content-label">{{ getCharacteristic('US02')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('US02') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('Surft')">
										<div class="card-content-label">{{ getCharacteristic('Surft')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('Surft') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('PP03')">
										<div class="card-content-label">{{ getCharacteristic('PP03')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('PP03') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('PP05')">
										<div class="card-content-label">{{ getCharacteristic('PP05')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('PP05') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('PP06')">
										<div class="card-content-label">{{ getCharacteristic('PP06')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('PP06') | copoCharac }}
										</div>
									</div>
									<div class="card-content-info" *ngIf="getCharacteristic('CF01')">
										<div class="card-content-label">{{ getCharacteristic('CF01')?.description }}
										</div>
										<div class="card-content-value">{{ getCharacteristic('CF01') | copoCharac }}
										</div>
									</div>
								</div>
							</div>
						</mat-expansion-panel>
					</div>
					<div class="card-block grid-column-one-full"
						*ngIf="rowDataBlockedBatches && rowDataBlockedBatches.length > 0 && gridBatchBlockedOptions">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header class="card-title">
								<mat-panel-title class="card-content-title">
									<span class="card-title-label" translate>order-card.batches-blocked</span>
									<span class="card-title-label" translate
										[translateParams]="{value: sumGrossBlockedBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumGrossBlockedBatches">order-card.gross</span>
									<span translate
										[translateParams]="{value: sumNetBlockedBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumNetBlockedBatches">order-card.net</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="copo-card-grid-container">
								<ag-grid-angular class="ag-theme-balham" [gridOptions]="gridBatchBlockedOptions"
									[modules]="agGridModules" (gridReady)="onGridReady($event)"
									(viewportChanged)="onViewportChanged($event)"></ag-grid-angular>
							</div>
						</mat-expansion-panel>
					</div>
					<div class="card-block sub-title grid-column-one-full" *ngIf="
						(rowDataReadyToShipBatches && rowDataReadyToShipBatches.length > 0)
						|| (rowDataCalledBatches && rowDataCalledBatches.length > 0)
						|| (rowDataLandTransitBatches && rowDataLandTransitBatches.length > 0)
						|| (rowDataAtReshipperBatches && rowDataAtReshipperBatches.length > 0)
						|| (rowDataOnVesselBatches && rowDataOnVesselBatches.length > 0)
						|| (rowDataOverseasTransitBatches && rowDataOverseasTransitBatches.length > 0)
						|| (rowDataTransitToCustomerBatches && rowDataTransitToCustomerBatches.length > 0)
						|| (rowDataConsignmentStockBatches && rowDataConsignmentStockBatches.length > 0)
						">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header class="card-title">
								<mat-panel-title class="card-content-title">
									<span class="card-title-label" translate>order-card.batches-available</span>
									<span class="card-title-label" translate
										[translateParams]="{value: sumGrossAvailableBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumGrossAvailableBatches">order-card.gross</span>
									<span translate
										[translateParams]="{value: sumNetAvailableBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumNetAvailableBatches">order-card.net</span>
								</mat-panel-title>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<ng-container
								*ngIf="rowDataReadyToShipBatches && rowDataReadyToShipBatches.length > 0 && gridBatchReadyToShipOptions">
								<div class="card-sub-title">
									<span class="padding-left card-title-label"
										translate>order-card.batches-ready-to-ship</span>
									<span class="card-title-label" translate
										[translateParams]="{value: sumGrossReadyToShipBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumGrossReadyToShipBatches">order-card.gross</span>
									<span translate
										[translateParams]="{value: sumNetReadyToShipBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumNetReadyToShipBatches">order-card.net</span>
								</div>
								<div class="copo-card-grid-container">
									<ag-grid-angular class="ag-theme-balham" [gridOptions]="gridBatchReadyToShipOptions"
										[modules]="agGridModules" (gridReady)="onGridReady($event)"
										(viewportChanged)="onViewportChanged($event)"></ag-grid-angular>
								</div>
							</ng-container>
							<ng-container
								*ngIf="(rowDataCalledBatches && rowDataCalledBatches.length > 0) && (gridBatchCalledOptions && user.hasService('PCALL'))">
								<div class="card-sub-title">
									<span class="padding-left card-title-label"
										translate>order-card.batches-called</span>
									<span class="card-title-label" translate
										[translateParams]="{value: sumGrossCalledBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumGrossCalledBatches">order-card.gross</span>
									<span translate
										[translateParams]="{value: sumNetCalledBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumNetCalledBatches">order-card.net</span>
								</div>
								<div class="copo-card-grid-container">
									<ag-grid-angular class="ag-theme-balham" [gridOptions]="gridBatchCalledOptions"
										[modules]="agGridModules" (gridReady)="onGridReady($event)"
										(viewportChanged)="onViewportChanged($event)"></ag-grid-angular>
								</div>
							</ng-container>
							<ng-container
								*ngIf="rowDataLandTransitBatches && rowDataLandTransitBatches.length > 0 && gridBatchLandTransitOptions">
								<div class="card-sub-title">
									<span class="padding-left card-title-label"
										translate>order-card.batches-land-transit</span>
									<span class="card-title-label" translate
										[translateParams]="{value: sumGrossLandTransitBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumGrossLandTransitBatches">order-card.gross</span>
									<span translate
										[translateParams]="{value: sumNetLandTransitBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumNetLandTransitBatches">order-card.net</span>
								</div>
								<div class="copo-card-grid-container">
									<ag-grid-angular class="ag-theme-balham" [gridOptions]="gridBatchLandTransitOptions"
										[modules]="agGridModules" (gridReady)="onGridReady($event)"
										(viewportChanged)="onViewportChanged($event)"></ag-grid-angular>
								</div>
							</ng-container>
							<ng-container
								*ngIf="rowDataAtReshipperBatches && rowDataAtReshipperBatches.length > 0 && gridBatchAtReshipperOptions">
								<div class="card-sub-title">
									<span class="padding-left card-title-label"
										translate>order-card.batches-at-reshipper</span>
									<span class="card-title-label" translate
										[translateParams]="{value: sumGrossAtReshipperBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumGrossAtReshipperBatches">order-card.gross</span>
									<span translate
										[translateParams]="{value: sumNetAtReshipperBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumNetAtReshipperBatches">order-card.net</span>
								</div>
								<div class="copo-card-grid-container">
									<ag-grid-angular class="ag-theme-balham" [gridOptions]="gridBatchAtReshipperOptions"
										[modules]="agGridModules" (gridReady)="onGridReady($event)"
										(viewportChanged)="onViewportChanged($event)"></ag-grid-angular>
								</div>
							</ng-container>
							<ng-container
								*ngIf="rowDataOnVesselBatches && rowDataOnVesselBatches.length > 0 && gridBatchOnVesselOptions">
								<div class="card-sub-title">
									<span class="padding-left card-title-label"
										translate>order-card.batches-on-vessel</span>
									<span class="card-title-label" translate
										[translateParams]="{value: sumGrossOnVesselBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumGrossOnVesselBatches">order-card.gross</span>
									<span translate
										[translateParams]="{value: sumNetOnVesselBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumNetOnVesselBatches">order-card.net</span>
								</div>
								<div class="copo-card-grid-container">
									<ag-grid-angular class="ag-theme-balham" [gridOptions]="gridBatchOnVesselOptions"
										[modules]="agGridModules" (gridReady)="onGridReady($event)"
										(viewportChanged)="onViewportChanged($event)"></ag-grid-angular>
								</div>
							</ng-container>
							<ng-container
								*ngIf="rowDataOverseasTransitBatches && rowDataOverseasTransitBatches.length > 0 && gridBatchOverseasTransitOptions">
								<div class="card-sub-title">
									<span class="padding-left card-title-label"
										translate>order-card.batches-overseas-transit</span>
									<span class="card-title-label" translate
										[translateParams]="{value: sumGrossOverseasTransitBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumGrossOverseasTransitBatches">order-card.gross</span>
									<span translate
										[translateParams]="{value: sumNetOverseasTransitBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumNetOverseasTransitBatches">order-card.net</span>
								</div>
								<div class="copo-card-grid-container">
									<ag-grid-angular class="ag-theme-balham"
										[gridOptions]="gridBatchOverseasTransitOptions" [modules]="agGridModules"
										(gridReady)="onGridReady($event)"
										(viewportChanged)="onViewportChanged($event)"></ag-grid-angular>
								</div>
							</ng-container>
							<ng-container
								*ngIf="rowDataTransitToCustomerBatches && rowDataTransitToCustomerBatches.length > 0 && gridBatchTransitToCustomerOptions">
								<div class="card-sub-title">
									<span class="padding-left card-title-label"
										translate>order-card.batches-transit-to-customer</span>
									<span class="card-title-label" translate
										[translateParams]="{value: sumGrossTransitToCustomerBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumGrossTransitToCustomerBatches">order-card.gross</span>
									<span translate
										[translateParams]="{value: sumNetTransitToCustomerBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumNetTransitToCustomerBatches">order-card.net</span>
								</div>
								<div class="copo-card-grid-container">
									<ag-grid-angular class="ag-theme-balham"
										[gridOptions]="gridBatchTransitToCustomerOptions" [modules]="agGridModules"
										(gridReady)="onGridReady($event)"
										(viewportChanged)="onViewportChanged($event)"></ag-grid-angular>
								</div>
							</ng-container>
							<ng-container
								*ngIf="rowDataConsignmentStockBatches && rowDataConsignmentStockBatches.length > 0 && gridBatchConsignmentStockOptions">
								<div class="card-sub-title">
									<span class="padding-left card-title-label"
										translate>order-card.batches-consignment-stock</span>
									<span class="card-title-label" translate
										[translateParams]="{value: sumGrossConsignmentStockBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumGrossConsignmentStockBatches">order-card.gross</span>
									<span translate
										[translateParams]="{value: sumNetConsignmentStockBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumNetConsignmentStockBatches">order-card.net</span>
								</div>
								<div class="copo-card-grid-container">
									<ag-grid-angular class="ag-theme-balham"
										[gridOptions]="gridBatchConsignmentStockOptions" [modules]="agGridModules"
										(gridReady)="onGridReady($event)"
										(viewportChanged)="onViewportChanged($event)"></ag-grid-angular>
								</div>
							</ng-container>
						</mat-expansion-panel>
					</div>
					<div class="card-block grid-column-one-full"
						*ngIf="rowDataDeliveredBatches && rowDataDeliveredBatches.length > 0 && gridBatchDeliveredOptions">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header class="card-title">
								<mat-panel-title class="card-content-title">
									<span class="card-title-label" translate>order-card.batches-delivered</span>
									<span class="card-title-label" translate
										[translateParams]="{value: sumGrossDeliveredBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumGrossDeliveredBatches">order-card.gross</span>
									<span translate
										[translateParams]="{value: sumNetDeliveredBatches | copoNumber: 'weight':'t'}"
										*ngIf="sumNetDeliveredBatches">order-card.net</span>
								</mat-panel-title>
								<a color="primary" (click)="$event.preventDefault();seeAllBatches()" class="view-all"
									href="#">
									<span translate>see.all.batches</span>
								</a>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>
							<div class="copo-card-grid-container">
								<ag-grid-angular class="ag-theme-balham" [gridOptions]="gridBatchDeliveredOptions"
									[modules]="agGridModules" (gridReady)="onGridReady($event)"
									(viewportChanged)="onViewportChanged($event)"></ag-grid-angular>
							</div>
						</mat-expansion-panel>
					</div>
					<div class="grid-column-one-full" #documents copoAfterViewInit
						(afterviewinit)="autoScrollToElement(documents)" *ngIf="gridCommercialDocumentsOptions">
						<mat-expansion-panel [expanded]="true" class="card-info-block">
							<mat-expansion-panel-header>
								<mat-panel-title class="card-content-title">
									<span [ngClass]="{'highlight-title': isCommercialDocumentFragment}"
										translate>order-card.commercial-documents</span>
								</mat-panel-title>
								<div
									*ngIf="documentResult && documentResult.results && documentResult.results.length > 0">
									<a color="primary" (click)="$event.preventDefault();seeAllDocuments()"
										class="view-all" href="#">
										<span translate>see.all.documents</span>
									</a>
								</div>
							</mat-expansion-panel-header>
							<mat-divider class="margin-expansion-panel"></mat-divider>

							<div class="copo-card-grid-container">
								<ag-grid-angular *ngIf="!hasCommercialDocumentError" class="ag-theme-balham"
									[gridOptions]="gridCommercialDocumentsOptions"
									[overlayNoRowsTemplate]="overlayNoDocumentsTemplate" [modules]="agGridModules"
									(gridReady)="onGridReady($event)"
									(viewportChanged)="onViewportChanged($event)"></ag-grid-angular>
								<div *ngIf="hasCommercialDocumentError" class="document-error-box">
									<div translate>order-card.due-to-technical-issue</div>
									<mat-icon class="error-icon" svgIcon="md:running_with_error"></mat-icon>
									<div translate>order-card.we-are-actively-working</div>
								</div>
							</div>
						</mat-expansion-panel>
					</div>
					<ng-container *ngFor="let ecall of ecallData">
						<div class="grid-column-one-full" *ngIf="ecallData && ecallData.length>0">
							<mat-expansion-panel [expanded]="true" class="card-info-block">
								<mat-expansion-panel-header>
									<mat-panel-title class="card-content-title">
										<span translate>ecall-off-information-box</span>
									</mat-panel-title>
								</mat-expansion-panel-header>
								<mat-divider class="margin-expansion-panel"></mat-divider>
								<div class="card-content-block-col-4">
									<div class="card-contents-infos">
										<div class="card-content-info">
											<div class="card-content-label" translate>
												ecall-off.customer-call-off-reference</div>
											<div class="card-content-value">{{ecall.customerCallOffReference}}</div>
										</div>
									</div>
									<div class="card-contents-infos">
										<div class="card-content-info">
											<div class="card-content-label" translate>ecall-total-volume-called</div>
											<div class="card-content-value">{{ecall.quantitySum !== undefined ?
												(ecall.quantitySum | copoNumber:'weight':'t') : UNDERSCORE}}</div>
										</div>
									</div>
									<div class="card-contents-infos">
										<div class="card-content-info">
											<div class="card-content-label" translate>ecall-off-creation-date</div>
											<div class="card-content-value">{{ecall.callOffCreationTimestamp |
												copoDate:'date' }}
											</div>
										</div>
									</div>
									<div class="card-contents-infos">
										<div class="card-content-info">
											<div class="card-content-label" translate>ecall-off-call-creater</div>
											<div class="card-content-value">{{ecall.callOffCreator ?
												ecall.callOffCreator : UNDERSCORE}}</div>
										</div>
									</div>
								</div>
								<div class="copo-card-grid-container" *ngIf="ecall.items && ecall.items.length > 0">
									<ag-grid-angular class="ag-theme-balham" [gridOptions]="gridEcallCalledBatches"
										[modules]="agGridModules" [rowData]="ecall.items"
										(gridReady)="onGridReady($event)"
										(viewportChanged)="onViewportChanged($event)"></ag-grid-angular>
								</div>
							</mat-expansion-panel>
						</div>
					</ng-container>
					<ng-container *ngFor="let ecall of ecallDataVolume">
						<div class="grid-column-one-full" *ngIf="ecallDataVolume && ecallDataVolume.length>0">
							<mat-expansion-panel [expanded]="true" class="card-info-block">
								<mat-expansion-panel-header>
									<mat-panel-title class="card-content-title">
										<span translate>ecall-off-information-box</span>
									</mat-panel-title>
								</mat-expansion-panel-header>
								<mat-divider class="margin-expansion-panel"></mat-divider>
								<div class="card-content-block-col-4">
									<div class="card-contents-infos">
										<div class="card-content-info">
											<div class="card-content-label" translate>
												ecall-off.customer-call-off-reference</div>
											<div class="card-content-value">{{ecall.customerReference}}</div>
										</div>
									</div>
									<div class="card-contents-infos">
										<div class="card-content-info">
											<div class="card-content-label" translate>ecall-total-volume-called</div>
											<div class="card-content-value">{{ecall.quantitySum !== undefined ?
												(ecall.quantitySum | copoNumber:'weight':'t') : UNDERSCORE}}</div>
										</div>
									</div>
									<div class="card-contents-infos">
										<div class="card-content-info">
											<div class="card-content-label" translate>ecall-off-creation-date</div>
											<div class="card-content-value">{{ecall.rowCreationDate | copoDate:'date' }}
											</div>
										</div>
									</div>
									<div class="card-contents-infos">
										<div class="card-content-info">
											<div class="card-content-label" translate>ecall-off-call-creater</div>
											<div class="card-content-value">{{ecall.callCreator ? ecall.callCreator :
												UNDERSCORE}}</div>
										</div>
									</div>
								</div>
								<div class="copo-card-grid-container"
									*ngIf="ecall.ecallVolumes  && ecall.ecallVolumes.length > 0">
									<ag-grid-angular class="ag-theme-balham" [gridOptions]="gridEcalledVolumes"
										[modules]="agGridModules" [rowData]="ecall.ecallVolumes"
										(gridReady)="onGridReady($event)"
										(viewportChanged)="onViewportChanged($event)"></ag-grid-angular>
								</div>
							</mat-expansion-panel>
						</div>
					</ng-container>
				</div>
			</ng-container>
		</ng-container>
	</ng-container>
	<ng-template #offline>
		<copo-offline></copo-offline>
	</ng-template>
	<ng-template #loading>
		<copo-loading-spinner></copo-loading-spinner>
	</ng-template>
</div>